// ---Third-party imports
import React, {useState, useRef} from 'react'
import clsx from 'clsx'

// ---Framework imports
import {Sel} from 'uix/registries'
import {useSelector} from 'uix/hooks'

// ---Local imports
import S from './nativeComps.scss'
import {useEffect} from 'react'

export const Form = ({children}) => {
  return <div className={clsx('form', S.form)}>{children}</div>
}

const FormItem = ({children}) => {
  return <li className={clsx('formItem', S.formItem)}>{children}</li>
}

const FormGroup = ({title, children}) => {
  if (title) {
    return (
      <div className={clsx('formGroup', S.formGroup)}>
        <div className={clsx('title', S.title)}>{title}</div>
        <ul>{children}</ul>
      </div>
    )
  } else {
    return <ul className={clsx('formGroup', S.formGroup)}>{children}</ul>
  }
}

const Checkbox = ({label, className, key = '1', checked = false, onChange, onClick, ...props}) => {
  let [active, setActive] = useState(false)
  useEffect(() => {
    checked && setActive(checked)
  }, [checked])
  let toggleActive = e => {
    onChange && onChange(e)
    setActive(e.target.checked)
  }
  return (
    <a className={clsx(S.checkbox, className, 'checkbox')} key={key} {...props}>
      <label>
        <span className={clsx('checker', S.checker, active && S.active, 'active')}> </span>
        <input onChange={e => toggleActive(e)} type="checkbox" />
        <span className={clsx('label', S.label)}>{label}</span>
      </label>
    </a>
  )
}

Form.Checkbox = ({...props}) => <FormItem children={<Checkbox {...props} />} />
Form.Group = FormGroup

export const Dropdown = ({
  className,
  disabled,
  simple,
  options,
  onSetValue,
  onChange,
  selection,
  selected,
  placeholder,
  experimental,
}) => {
  let i18n = useSelector(Sel.i18n)
  let ref = useRef()
  let [focused, setFocused] = useState(false)
  let [optText, setOptText] = useState(false)
  let [open, setOpen] = useState(false)

  const onFocus = () => setFocused(true)
  const onBlur = () => setFocused(false)
  const onChanged = e => {
    !onChange ? onSetValue && onSetValue(e.target.value) : onChange
    ref.current && ref.current.blur()
  }
  const onOpen = e => {
    e.stopPropagation()
    setOpen(!open)
  }

  const handleOption = (e, opt) => {
    onChanged(e)
    setOptText(opt.text)
  }
  let minWidth = 120
  if (experimental) {
    return (
      <Button
        className={clsx(S.experimentalDropdown, S.chevron)}
        style={{minWidth: `${minWidth}px`}}
        basic
        content={optText || placeholder}
        onClick={e => onOpen(e)}
      >
        {open && (
          <div className={S.select}>
            {options &&
              options.map((opt, i) => {
                return (
                  <option onClick={e => handleOption(e, opt)} key={i} value={opt.value || opt}>
                    {opt.text || opt ? opt.text || i18n.get(opt) : 'Missing text'}
                  </option>
                )
              })}
          </div>
        )}
      </Button>
    )
  } else {
    return (
      <span
        className={clsx(
          'dropdown',
          className,
          S.dropdown,
          !simple && S.chevron,
          focused && S.focused,
          selection && S.selection
        )}
      >
        <select
          ref={ref}
          onBlur={onBlur}
          onFocus={onFocus}
          defaultValue={selected || (placeholder && 'placeholder') || null}
          disabled={disabled}
          onChange={e => onChanged(e)}
        >
          {placeholder && (
            <option value="placeholder" disabled>
              {placeholder}
            </option>
          )}
          {options &&
            options.map((opt, i) => {
              return (
                <option key={i} value={opt.value || opt}>
                  {opt.text || opt ? opt.text || i18n.get(opt) : 'Missing text'}
                </option>
              )
            })}
        </select>
      </span>
    )
  }
}
export const Button = ({active, basic, className, children, content, onClick, ...props}) => {
  return (
    <button
      className={clsx(className, S.button, active && S.active, basic && S.basic)}
      onClick={onClick}
      {...props}
    >
      {children}
      {content}
    </button>
  )
}
